export default "__VITE_ASSET__Bhu1G7_1__"